// extracted by mini-css-extract-plugin
var _1 = "TermsAndConditions_termsAndConditionsWrapper__wJWuj";
export { _1 as "termsAndConditionsWrapper" }
